import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import UpdateFlowStep from './UpdateFlowStep'

class RoleLevelSalaryStep extends UpdateFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.update.steps.role_level_salary.title'),
      component,
      i18n.t('contract_versions.flows.update.steps.role_level_salary.description')
    )
  }
}

export default RoleLevelSalaryStep
